import React from 'react';
import 'assets/styles/RectCard.css'; // Import the CSS file for styling

export default function Aligneurs() {
  return (
    <>
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h1>Coming Soon</h1>
        <p>Notre nouveau site Web passionnant est en construction. Restez à l'écoute des mises à jour!</p>
      </div>
    </div>
    </>
  );
};

